import { render, staticRenderFns } from "./PvExpandableAuthorsLinks.vue?vue&type=template&id=d6177154&"
import script from "./PvExpandableAuthorsLinks.vue?vue&type=script&lang=js&"
export * from "./PvExpandableAuthorsLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports